type Props = {
  color: string;
};

export default function TransitionIcon({ color }: Props) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6375_4)">
        <path
          d="M4.5 3.5H12.5714C12.9503 3.5 13.3137 3.65804 13.5816 3.93934C13.8495 4.22064 14 4.60218 14 5V11C14 11.3978 13.8495 11.7794 13.5816 12.0607C13.3137 12.342 12.9503 12.5 12.5714 12.5H3"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          x="1"
          y="5.80078"
          width="6"
          height="1.33"
          rx="0.665"
          fill={color}
        />
        <rect x="2" y="9" width="4" height="1.33" rx="0.665" fill={color} />
      </g>
      <defs>
        <clipPath id="clip0_6375_4">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
